import { Routes } from '@angular/router';
import { AuthView } from './auth';
import { SearchView } from './search';
import { SettingsView } from './settings';
import { PoliciesView } from './policies';
import { EverView } from './ever';
import { AboutView } from './about';
import { ProfileView } from './profile';
import { ChatView } from './chat';
import { ImagesView } from './images';
import { NewsDetailComponent } from './news';
import { ContactsView } from './contacts';
import { AuthGuard, GuestGuard, guestGuard } from './auth.service';

export const routes: Routes = [
  { path: '', redirectTo: 'search', pathMatch: 'full' },
  { path: 'auth', component: AuthView, canActivate: [GuestGuard] },
  { path: 'search', component: SearchView, canActivate: [GuestGuard] },
  { path: 'contacts', component: ContactsView, canActivate: [AuthGuard] },
  { path: 'image/:ownerId/:imageId', component: ImagesView, canActivate: [AuthGuard] },
  { path: 'news/:ownerId/:newsId', component: NewsDetailComponent, canActivate: [AuthGuard] },
  { path: 'job/:ownerId/:jobId', loadComponent: () => import('./jobs'), canActivate: [AuthGuard] },
  { path: 'product/:ownerId/:productId', loadComponent: () => import('./products'), canActivate: [AuthGuard] },
  { path: 'video/:ownerId/:videoId', loadComponent: () => import('./videos'), canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsView, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileView, canActivate: [AuthGuard] },
  { path: 'profile/:profileId', component: ProfileView, canActivate: [AuthGuard] },
  { path: 'ads', loadComponent: () => import('./ads'), canActivate: [AuthGuard] },
  { path: 'planner', loadComponent: () => import('./planner'), canActivate: [AuthGuard] },
  { path: 'appointment', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'appointments', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'calendar', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'reminder', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'reminders', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'notes', redirectTo: 'planner', pathMatch: 'full' },
  { path: 'workplace', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'drive', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'docs', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'sheets', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'slides', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'resumes', loadComponent: () => import('./workplace'), canActivate: [AuthGuard] },
  { path: 'education', loadComponent: () => import('./education'), canActivate: [AuthGuard] },
  { path: 'games', loadComponent: () => import('./games'), canActivate: [AuthGuard] },
  { path: 'services', loadComponent: () => import('./services'), canActivate: [AuthGuard] },
  { path: 'lifeline', loadComponent: () => import('./lifeline'), canActivate: [AuthGuard] },
  { path: 'blood', redirectTo: 'lifeline', pathMatch: 'full' },
  { path: 'organ', redirectTo: 'lifeline', pathMatch: 'full' },
  { path: 'chat/:id', component: ChatView, canActivate: [AuthGuard] },
  { path: 'policies', component: PoliciesView },
  { path: 'admin', loadComponent: () => import('./admin'), canActivate: [AuthGuard] },
  { path: 'ever', component: EverView },
  { path: 'help', redirectTo: 'ever', pathMatch: 'full' },
  { path: 'about', component: AboutView },
  { path: '**', redirectTo: 'search' }
];
